<template>
    <ies-form-field :field="field">
        <v-time-picker format="24hr" v-model="input"  @mouseup.native.stop="updateField()" landscape ></v-time-picker>
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-text',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            input: this.field.value
        }
    },
    methods: {
        updateField: function(){
            this.field.value = this.input
        }
   }
}
</script>


